<template>
  <div>
    <h1>Settings</h1>
    <h2>Notifications</h2>
    <NotificationsViewVue />
  </div>
</template>

<script>
import NotificationsViewVue from './NotificationsView.vue'

export default {
  components: {
    NotificationsViewVue,
  },
}
</script>

<style lang="scss" scoped></style>
